import request from "./../utils/request";

export async function getPermissions() {
    return await request.get("permissions");
}
